module.exports = __webpack_public_path__ + "assets/img/gift-shelf-43544d81.png";